import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './SchoolGroupTokenUsage.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';
import {modifiedDate} from '../middleware/dateControl';

export default function SchoolGroupTokenUsage(prop) {	
	const navigate = useNavigate();
	
	let orgId = prop.orgId;
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [data, setData] = useState([]);
	
	const fetchData = async () => {
		getData('schoolApi/listGroupUsageSummary?orgId=' + orgId, navigate)
		.then(res => {
				setData(res.data);
			
				setFetchCompleted(true);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	function unsecuredCopyToClipboard(text) {
		const textArea = document.createElement("textarea");
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
		try {
			document.execCommand('copy');
		} catch (err) {
			console.error('Unable to copy to clipboard', err);
		}
		document.body.removeChild(textArea);
	}
	return (<div className={s.mainHolder}>
		<div style={{display:"flex"}}>
			<GreenButton isEnabled={true} clickedAction={()=>{
				let copy = "tutor group id\tstart date\tteacher\tstudent\n";
				for(let d of data) {
					copy += d.tutorGroupId + "\t" + modifiedDate(d.startDate) + "\t" + d.teacherUsername + "\t" + d.studentUsername + "\n";
				}
				unsecuredCopyToClipboard(copy);
			}} bText={"Copy Data"} />	
		</div>
		<div className={s.rowHolder}>
			<div>TG Id</div>
			<div style={{flexBasis:"200px"}}>Start Date</div>
			<div style={{flexBasis:"200px"}}>Teacher</div>
			<div>Ticket id</div>
			<div style={{flexBasis:"200px"}}>Student</div>
		</div>
	
		{
			data.map((d, indexD)=>(<div key={indexD} className={s.rowHolder} style={(indexD % 2 == 0) ? {background:"#dae6e8"} :{}}>
				<div>{d.tutorGroupId}</div>
				<div style={{flexBasis:"200px"}}>{modifiedDate(d.startDate)}</div>
				<div style={{flexBasis:"200px"}}>({d.teacherId}){d.teacherUsername}</div>
				<div>{d.ticketId}</div>
				<div style={{flexBasis:"200px"}}>({d.studentId}){d.studentUsername}</div>
			</div>))
		}
	</div>);
	
}

